<script>
    import { t } from "../../../lang/lang.js";
    import PopupButton from "../forms/PopupButton.svelte";

    export let url;
    let input;
    let timeout;

    async function copy(event) {
        input.select();
        document.execCommand('copy');
        input.selectionStart = input.selectionEnd;
        if (timeout) {
            clearTimeout(timeout);
        }
        event.target.innerText = t('widget.btn_copy_2');
        timeout = setTimeout(() => {
            event.target.innerText = t('widget.btn_copy')
        }, 2000);
    }
</script>

<div class="arsize_qr_input">
    <input class="arsize_form_control"
           bind:this={input} type="text" name="url" value={ url } readonly />
</div>
<div class="arsize_qr_input">
    <PopupButton width100={true} on:click={copy}>
        <span slot="text">{ t('widget.btn_copy') }</span>
    </PopupButton>
</div>

<style>
    .arsize_qr_input {
        margin-bottom: 14px;
    }
    .arsize_form_control {
        height: auto;
        width: 100%;
        border: 2px solid #BEC7D2;
        font-size: 14px;
        font-weight: normal;
        color: #7F8287;
        padding: 17px 10px 18px 10px;
        border-radius: 10px 10px 10px 10px;
        background: #ececec;
        text-align: center;
        box-sizing: border-box;
    }
    .arsize_form_control:focus {
        outline: none;
        box-shadow: none;
    }
    @media(max-width: 1279.98px) {
        .arsize_qr_input {
            margin-bottom: 8px;
        }
        .arsize_form_control {
            border-radius: 8px;
            font-size: 12px;
        }
    }
</style>